import { ResourceDetailFeature } from '@cibo/ui'
import { EarlyAdopterTillageTaskEditor } from './EarlyAdopterTillageTaskEditor'
import { RDEarlyAdopterTillage } from './types'

export const EarlyAdopterTillageFeature: ResourceDetailFeature<RDEarlyAdopterTillage> = {
  traitId: 'earlyAdopterTillage',
  TaskEditor: EarlyAdopterTillageTaskEditor,
}
